import '../globals.scss';
import '../styles/Login.scss';
import Button from 'react-bootstrap/Button';
import logoPreto from '../assets/icons/logo_preto.svg';
import { Form } from 'react-bootstrap';
import PublicApp from '../PublicApp';
import { useTranslation } from 'react-i18next';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../helpers/authProvider';

const Login = () => {
    const { t } = useTranslation();
    const { instance } = useMsal();

    const handleLogin = (e: React.FormEvent) => {
        e.preventDefault();
        instance.loginRedirect(loginRequest).catch((error) => {
            console.error("Login error:", error);
        });
    };

    return (
        <PublicApp>
            <div className='card-login'>
                <div className='d-flex justify-content-center'>
                    <img src={logoPreto} alt='Logo Unipar' width={130} />
                </div>
                <Form onSubmit={handleLogin}>
                    <div className='buttons mt-lg-5 w-100'>
                        <Button id="btnEnviar" className='btn-primary mb-lg-3' type="submit">{t('login.login')}</Button>
                    </div>
                </Form>
            </div>
        </PublicApp>
    )
}

export default Login;